import { Divider, Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectExpandedModsDialog } from 'store/redux-store/placement-mods/selectors';
import { HousingInfo } from './HousingInfo';
import { preferencesModStyles } from './PreferencesMod.styles';
import { TravelerInfo } from './TravelerInfo';

export const PreferencesMod = () => {
  // Get styles
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { classes } = preferencesModStyles();

  return (
    <Grid container className={classes.gridContainer} sx={{ width: !isExpanded ? '550px' : null }}>
      <Grid className={classes.container}>
        <HousingInfo />
      </Grid>
      <Grid xs={12} className={classes.divider}>
        <Divider />
      </Grid>
      <Grid xs={12} className={classes.divider}>
        <TravelerInfo />
      </Grid>
    </Grid>
  );
};
